import { IReportSection, MarkerClasses, SectionIds } from '@modeso/aumico-lib-annualreport-fe';
import { SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY } from '../../toc-page/sections-titles-localization-keys-dictionary';

export const SECTION_ID_TO_SECTION_MAP = new Map<string, IReportSection>([
    [
        SectionIds.BALANCE,
        {
            markerClassName: MarkerClasses.BALANCE,
            title: SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.BALANCE].localizationKey,
            id: SectionIds.BALANCE,
        },
    ],
    [
        SectionIds.INCOME,
        {
            markerClassName: MarkerClasses.INCOME,
            title: SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.INCOME].localizationKey,
            id: SectionIds.INCOME,
        },
    ],
    [
        SectionIds.APBS,
        {
            markerClassName: MarkerClasses.ACCOUNT_PROOF_BALANCE,
            title: SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.APBS].localizationKey,
            id: SectionIds.APBS,
        },
    ],
    [
        SectionIds.APIS,
        {
            markerClassName: MarkerClasses.ACCOUNT_PROOF_INCOME,
            title: SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.APIS].localizationKey,
            id: SectionIds.APIS,
        },
    ],
    [
        SectionIds.CASHFLOW,
        {
            markerClassName: MarkerClasses.CASHFLOW,
            title: SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.CASHFLOW].localizationKey,
            id: SectionIds.CASHFLOW,
        },
    ],
    [
        SectionIds.NOTES,
        {
            markerClassName: MarkerClasses.NOTES,
            title: SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.NOTES].localizationKey,
            id: SectionIds.NOTES,
        },
    ],
    [
        SectionIds.AOP,
        {
            markerClassName: MarkerClasses.AOP,
            title: SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.AOP].localizationKey,
            id: SectionIds.AOP,
        },
    ],
    [
        SectionIds.EMS,
        {
            markerClassName: MarkerClasses.EMS,
            title: SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.EMS].localizationKey,
            id: SectionIds.EMS,
        },
    ],
    [
        SectionIds.FAS,
        {
            markerClassName: MarkerClasses.FAS,
            title: SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.FAS].localizationKey,
            id: SectionIds.FAS,
        },
    ],
    [
        SectionIds.APPENDIX,
        {
            markerClassName: MarkerClasses.APPENDIX,
            title: SECTIONS_TITLES_LOCALIZATION_KEYS_DICTIONARY[SectionIds.APPENDIX].localizationKey,
            id: SectionIds.APPENDIX,
        },
    ],
]);
